// Angular
import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {SignalRService} from '../../../../mbs/services/signalR/signal-r.service';
import {ToastrService} from 'ngx-toastr';
import {MbsNotification} from '../../../../mbs/models/notification.model';
import {NotificationService} from '../../../../mbs/services/notification/notification.service';

@Component({
    selector: 'kt-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit {
    dotAndPulseValue = false;
    notifications: any[];

    notificationDialog = false;
    selectedNotification: any;

    constructor(
        private cdr: ChangeDetectorRef,
        private signalRService: SignalRService,
        private toastrService: ToastrService,
        private notificationService: NotificationService
    ) {
    }

    ngOnInit(): void {
        this.getNotifications();

        this.signalRService.receivedPersonelNotification.subscribe((notification: MbsNotification) => {
            this.toastrService.info(notification.detail, notification.title);
            this.dotAndPulseValue = true;
            this.getNotifications();
            this.cdr.detectChanges();
        });

        this.signalRService.receivedGeneralNotification.subscribe((notification: MbsNotification) => {
            this.toastrService.info(notification.detail, notification.title);
            this.dotAndPulseValue = true;
            this.getNotifications();
            this.cdr.detectChanges();
        });
    }

    getNotifications() {
        this.notificationService.getNotifications().subscribe((notifications) => {
            this.notifications = notifications;
        });
    }

    selectedNotificationChanged(notification) {
        this.notificationService.updateNotificationStatus(notification).subscribe(() => {
            this.notificationDialog = true;
            this.selectedNotification = notification;
            this.getNotifications();
        });

    }
}
